import { createContext } from "react";

import type {
  BookingConflictErrorType,
  IApprovalBookingConflict,
} from "@ryde/shared";

export interface IBulkPreviewStepConflictsContext {
  conflicts: IApprovalBookingConflict[] | null;
  isPreview: boolean;
  onRefresh: (() => Promise<void>) | null;
  /**
   * Turns the gap sections into approvable ones, keyed by booking. Only the bulk date/time panel sets
   * it: there the gap check is a soft validation the operator may override row by row.
   */
  isGapConflictApprovable?: boolean;
  /** Per-panel section titles; an error type left out falls back to `booking.bulk.<errorType>`. */
  titleTranslationKeys?: Partial<Record<BookingConflictErrorType, string>>;
}

export const BulkPreviewStepConflictsContext =
  createContext<IBulkPreviewStepConflictsContext>({
    conflicts: null,
    onRefresh: null,
    isPreview: false,
  });
